const hotTopics = [
  { id: 1, name: '七月娱乐圈大地震', count: '12.6万', trend: 'up', tag: '爆' },
  { id: 2, name: '某顶流深夜发文', count: '9.8万', trend: 'up', tag: '热' },
  { id: 3, name: '综艺录制冲突完整版', count: '8.5万', trend: 'up', tag: '热' },
  { id: 4, name: '网红合约纠纷内幕', count: '7.2万', trend: 'down', tag: '' },
  { id: 5, name: '艺人片酬排行榜曝光', count: '6.9万', trend: 'up', tag: '新' },
  { id: 6, name: '黑料社七月深度盘点', count: '6.3万', trend: 'up', tag: '' },
  { id: 7, name: '暴走黑料独家揭秘', count: '5.8万', trend: 'up', tag: '荐' },
  { id: 8, name: '某选秀节目导演爆料', count: '5.4万', trend: 'down', tag: '' },
  { id: 9, name: '品牌代言翻车实录', count: '4.9万', trend: 'up', tag: '新' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            话题热榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            暴走黑料与黑料社最热话题实时追踪
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {hotTopics.map((topic, index) => (
            <div
              key={topic.id}
              className="flex items-center gap-4 px-4 py-3.5 border-b border-background-200/40 last:border-0 hover:bg-background-100/50 transition-colors cursor-pointer group"
            >
              <span className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold ${
                index < 3
                  ? 'bg-primary-500/15 text-primary-500'
                  : 'bg-background-200 text-foreground-400'
              }`}>
                {index + 1}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {topic.name}
                </p>
              </div>
              {topic.tag && (
                <span className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-semibold ${
                  topic.tag === '爆' ? 'bg-accent-500/15 text-accent-500' :
                  topic.tag === '热' ? 'bg-primary-500/15 text-primary-500' :
                  topic.tag === '新' ? 'bg-secondary-500/15 text-secondary-500' :
                  'bg-primary-500/10 text-primary-400'
                }`}>
                  {topic.tag}
                </span>
              )}
              <span className="flex-shrink-0 text-xs text-foreground-400 w-14 text-right">
                {topic.count}
              </span>
              <span className="flex-shrink-0">
                <i className={`text-sm ${
                  topic.trend === 'up'
                    ? 'ri-arrow-up-line text-accent-500'
                    : 'ri-arrow-down-line text-secondary-500'
                }`}></i>
              </span>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-500 cursor-pointer hover:underline whitespace-nowrap">
            查看完整热榜 <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </section>
  );
}